import Cookies from 'js-cookie'

$(document).ready(function () {
  $('#cookies-close').click(function(){
    Cookies.set('allow_cookies', 'yes')
    $('#cookies-bar').remove()
  })
})